var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.featuredPlaylists && _vm.featuredPlaylists.length)?_c('div',[_c('BaseSection',{attrs:{"title":"Featured Playlists"}},[_c('PlaylistsGridBlock',{attrs:{"playlists":_vm.featuredPlaylists,"type":"playlists","min-tile-width":"160px"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }